import type { ReactNode } from "react";
import { Link, NavLink, useMatch } from "react-router-dom";

import { useLogout, useSession } from "../auth";
import { MODE_PAGES, modeHref } from "../pages/scanRoute";
import { ItemSearch } from "./ItemSearch";

export function Shell({ children }: { children: ReactNode }) {
  const { me } = useSession();
  const logout = useLogout();
  // The uid of the scan being read, if any. Matching "/scans/:uid/*" also
  // matches "/scans/abc" with an empty splat, which is what we want: the item
  // table and the mode pages of one scan navigate the same way.
  const inScan = useMatch("/scans/:uid/*");
  const uid = inScan?.params.uid ?? "";

  return (
    <>
      <header className="shell-header">
        <h1><Link to="/" className="wordmark">Market</Link></h1>
        <nav className="shell-nav">
          {/* The mode links carry the scan you are reading. Without that,
              clicking Buy while on an old scan moves you to the LATEST scan's
              buy side: same page, different data, and nothing says so. */}
          <NavLink to={uid ? `/scans/${encodeURIComponent(uid)}` : "/"} end>
            Items
          </NavLink>
          {MODE_PAGES.map((mode) => (
            <NavLink key={mode} to={modeHref(uid, mode)}>{mode}</NavLink>
          ))}
          <NavLink to="/scans" end>Scans</NavLink>
          {/* No scan uid: a recipe is not a property of one scan, and its costs
              are drawn from the whole history. */}
          <NavLink to="/recipes" end>Recipes</NavLink>
          <NavLink to="/inventory" end>Bag</NavLink>
          <NavLink to="/watch" end>Watch</NavLink>
          <NavLink to="/trades" end>Hunter</NavLink>
          {/* Last, and after the destinations that are about the market: this
              one is about the account, and a setting is where a reader goes
              once rather than where they work. */}
          <NavLink to="/settings" end>Settings</NavLink>
        </nav>
        <ItemSearch />
        <span className="spacer" />
        {me ? (
          <>
            <span className="shell-sub">{me.display_name}</span>
            <button type="button" onClick={() => logout.mutate()}>
              Sign out
            </button>
          </>
        ) : null}
      </header>
      <main className="shell-main">{children}</main>
    </>
  );
}
